import BodyType from 'owa-service/lib/contract/BodyType';
import createEditorViewState from './createEditorViewState';
import { CompositeEditorViewState } from '../store/schema/CompositeEditorViewState';
import { getDefaultPreferredEditorTypes } from 'owa-mail-preferred-editor/lib/preferredEditorTypes';

export function createCompositeEditorViewState(
    content: string,
    bodyType: BodyType
): CompositeEditorViewState {
    return {
        ...createEditorViewState(content, false /*isDirty*/),
        bodyType,
        preferredEditors: getDefaultPreferredEditorTypes(),
    };
}
